import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <div className="flex items-center gap-2">
      <span className={`text-sm ${i18n.language === 'fr' ? 'text-gray-400' : 'text-designColor'}`}>EN</span>
      <button
        onClick={toggleLanguage}
        className="relative inline-flex items-center h-6 rounded-full w-11 bg-gray-200"
        role="switch"
        aria-checked={i18n.language === 'fr'}
      >
        <span
          className={`${
            i18n.language === 'fr' ? 'translate-x-6' : 'translate-x-1'
          } inline-block w-4 h-4 transform bg-designColor rounded-full transition-transform duration-200 ease-in-out`}
        />
      </button>
      <span className={`text-sm ${i18n.language === 'fr' ? 'text-designColor' : 'text-gray-400'}`}>FR</span>
    </div>
  );
};

export default LanguageSwitcher; 